import { isSuperAdminRoleType } from './accountRoleClassification';

export function isReportingSupervisorValue(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

export function canAccessBehaviourTracking({
  roleType,
  roleKey,
  roleName,
  isReportingSupervisor,
} = {}) {
  const type = String(roleType || '').trim().toLowerCase();
  const key = String(roleKey || '').trim().toLowerCase();
  const name = String(roleName || '').trim().toLowerCase();
  if (
    isSuperAdminRoleType(type) ||
    isSuperAdminRoleType(key) ||
    key === 'admin' ||
    name.includes('super admin')
  ) {
    return true;
  }
  return isReportingSupervisorValue(isReportingSupervisor);
}
